"use strict";


/*****************
 ** WEBPACK FOOTER
 ** ./components/locale-provider/style/index.js
 ** module id = 247
 ** module chunks = 0
 **/